import EmployeesView from '../EmployeesView.vue'
import EmployeesUpdate from '../layout/UpdateEmployees.vue'
import EmployeesRegister from '../layout/Register.vue'

export const employeesRoute = [
  {
    path: '/employees/',
    name: 'employees',
    component: EmployeesView,
    beforeEnter: (to, from, next) => {
      if (!localStorage.__access) next({ name: 'login' })
      next()
    },
    meta: {
      key: 'view_fun'
    }
  },
  {
    path: '/employees/edit/:id',
    name: 'employees-update',
    component: EmployeesUpdate,
    beforeEnter: (to, from, next) => {
      if (!localStorage.__access) next({ name: 'login' })
      next()
    },
    meta: {
      key: 'add_fun'
    }
  },
  {
    path: '/employees/new',
    name: 'employees-new',
    component: EmployeesRegister,
    beforeEnter: (to, from, next) => {
      if (!localStorage.__access) next({ name: 'login' })
      next()
    },
    meta: {
      key: 'edit_fun'
    }
  }
]
